import { makeStyles } from "@material-ui/core";

export const useRemoveSearchResultButtonStyles = makeStyles(() => ({
    closeIconButton: {
        marginLeft: "auto",
        float: "right"
    }
}));
